import { useEffect, useRef, useState } from "react";

/* ============================================================================
   PANEL DE AGREGAR · FASE 4 — lista virtualizada

   POR QUÉ: el tarifario más grande tiene 1.030 filas y el paciente con más
   pendientes 526. Aunque los datos ya estén en memoria, meter 1.030 filas en
   el DOM hace lento el scroll y, sobre todo, el MARCADO: cada clic vuelve a
   pintar la lista entera.

   SIN DEPENDENCIA NUEVA. `react-window` haría esto mismo, pero son 40 líneas
   y el proyecto no tiene ninguna librería de virtualización -- meter una para
   una sola lista no se paga.

   DOS DECISIONES QUE LA HACEN SEGURA:

   · Por debajo de `umbral` filas NO virtualiza: pinta todo. Con 20 filas el
     ahorro es cero y el riesgo de que algo no esté en el DOM no compensa.
   · Si no puede medir su propio alto (jsdom, un contenedor todavía sin
     layout), tampoco virtualiza. Un virtualizador que mide 0 no pinta NADA, y
     eso es peor que pintar de más.

   Sólo sirve para filas de ALTO FIJO. Las promociones se expanden, así que
   ésas no pasan por aquí.
   ========================================================================== */

export default function ListaVirtual({
    items,
    render,
    alto = 56,
    // Filas de más arriba y abajo del hueco visible. Sin margen, un scroll
    // rápido deja franjas en blanco mientras React se pone al día.
    sobrante = 8,
    umbral = 60,
    className,
    ...resto
}) {
    const cajaRef = useRef(null);
    const [desplazamiento, setDesplazamiento] = useState(0);
    const [altoCaja, setAltoCaja] = useState(0);

    useEffect(() => {
        const caja = cajaRef.current;
        if (!caja) return undefined;
        const medir = () => setAltoCaja(caja.clientHeight || 0);
        medir();
        // El panel puede cambiar de alto (ventana, franja masiva que aparece).
        if (typeof ResizeObserver === "undefined") {
            window.addEventListener("resize", medir);
            return () => window.removeEventListener("resize", medir);
        }
        const observador = new ResizeObserver(medir);
        observador.observe(caja);
        return () => observador.disconnect();
    }, []);

    const lista = items || [];
    const virtualizar = lista.length > umbral && altoCaja > 0;

    if (!virtualizar) {
        return (
            <div ref={cajaRef} className={className} {...resto}>
                {lista.map(render)}
            </div>
        );
    }

    const primera = Math.max(0, Math.floor(desplazamiento / alto) - sobrante);
    const ultima = Math.min(
        lista.length,
        Math.ceil((desplazamiento + altoCaja) / alto) + sobrante
    );
    const visibles = lista.slice(primera, ultima);

    return (
        <div
            ref={cajaRef}
            className={className}
            onScroll={(e) => setDesplazamiento(e.currentTarget.scrollTop)}
            data-virtualizada="si"
            {...resto}
        >
            {/* El alto total va aquí, para que la barra de scroll mida lo que
                mediría con las 1.030 filas dentro. */}
            <div style={{ height: lista.length * alto, position: "relative" }}>
                <div style={{ transform: `translateY(${primera * alto}px)` }}>
                    {visibles.map(render)}
                </div>
            </div>
        </div>
    );
}
